import * as React from "react"

interface OrderSummaryProps {
  order: any
  showFreeTrial?: boolean
}

export default function OrderSummary({ order, showFreeTrial = false }: OrderSummaryProps) {
  if (!order) {
    return null
  }

  return (
    <div className="order-summary bg-light border rounded p-3 mb-3">
      <h4 className="mb-3 text-dark">Order Summary</h4>
      
      <div className="order-details">
        <div className="plan-info mb-3">
          <h5 className="mb-2 text-secondary">{order.name}</h5>
          <p className="text-muted mb-3">{order.description}</p>
        </div>

        <div className="pricing-table border-top pt-3 mb-3">
          <div className="d-flex justify-content-between mb-2">
            <span>Subtotal:</span>
            <span>${order.price}</span>
          </div>
          
          {order.discount && (
            <div className="d-flex justify-content-between mb-2">
              <span>Discount:</span>
              <span className="text-success">-${order.discount}</span>
            </div>
          )}
          
          {order.tax && (
            <div className="d-flex justify-content-between mb-2">
              <span>Tax:</span>
              <span>${order.tax}</span>
            </div>
          )}
          
          <div className="d-flex justify-content-between border-top pt-2 fw-bold">
            <span>Total:</span>
            <span>${order.total || order.price}</span>
          </div>
        </div>

        {order.features && order.features.length > 0 && (
          <div className="features-list mb-3">
            <h6 className="mb-2 text-secondary">What's included:</h6>
            <ul className="ps-3">
              {order.features.map((feature: string, index: number) => (
                <li key={index} className="text-muted mb-1">{feature}</li>
              ))}
            </ul>
          </div>
        )}

        {showFreeTrial && order.trial_days && (
          <div className="trial-info bg-primary bg-opacity-10 border border-primary border-opacity-25 rounded p-3 mb-3">
            <div className="d-flex align-items-start">
              <i className="fas fa-info-circle text-primary me-2 mt-1"></i>
              <span>
                Your subscription starts today. 
                You will be charged ${order.total || order.price} immediately.
              </span>
            </div>
          </div>
        )}

        {order.billing_cycle && (
          <div className="billing-info mb-3">
            <p className="mb-0">
              <small className="text-muted">
                Billed {order.billing_cycle}
                {order.auto_renew && ' (auto-renews)'}
              </small>
            </p>
          </div>
        )}

        <div className="disclaimer border-top pt-3 mb-3">
          <p className="mb-0">
            <small className="text-muted">
              By completing this purchase, you agree to our{' '}
              <a href="/terms" target="_blank" className="text-decoration-none">Terms of Service</a> and{' '}
              <a href="/privacy" target="_blank" className="text-decoration-none">Privacy Policy</a>.
            </small>
          </p>
        </div>

        <div className="questions text-center">
          <p className="mb-0">
            <small>
              Questions? Contact us at{' '}
              <a href="mailto:support@example.com" className="text-decoration-none">support@example.com</a> or{' '}
              <a href="tel:+1-555-123-4567" className="text-decoration-none">(555) 123-4567</a>
            </small>
          </p>
        </div>
      </div>
    </div>
  )
}
